import i18n from 'i18n';

import { IObjProps } from 'shared/consts/types';

const i18nHelper: any = (key: string, params?: IObjProps) => i18n.t(key, params);

export { i18nHelper };
